import { ActivityStatusSchema } from "@redotech/redo-model/returns/temporal-status";
import { unaryStreamRpc } from "@redotech/rpc/definition";
import { zExt } from "@redotech/rpc/ext";
import { z } from "zod/v4";

export const getReturnCreationStatus = unaryStreamRpc({
  name: "getReturnCreationStatus",
  input: z.object({ returnId: zExt.objectId() }),
  output: z.object({
    workflowStartTime: z.date().nullish(),
    activityStatuses: z.array(ActivityStatusSchema),
  }),
});
